/* import __COLOCATED_TEMPLATE__ from './metric-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();